import React from 'react';
import './PageHero.scss';

const PageHero = ({ icon, title, subtitle, actions, className = '' }) => {
  return (
    <div className={`page-hero ${className}`}>
      <div className="page-hero__shape page-hero__shape--one" />
      <div className="page-hero__shape page-hero__shape--two" />
      <div className="page-hero__content">
        <div className="page-hero__icon">{icon}</div>
        <div className="page-hero__text">
          <h1 className="page-hero__title">{title}</h1>
          {subtitle ? <p className="page-hero__subtitle">{subtitle}</p> : null}
        </div>
      </div>
      {actions ? <div className="page-hero__actions">{actions}</div> : null}
    </div>
  );
};

export default PageHero;
